import DiscardSeatOnTravellerChange from './discard-seat-on-traveller-change-component';
import DiscardSeatOnTravellerChangeService from './discard-seat-on-traveller-change-service';

import './discard-seat-on-traveller-change.scss';

const MODULE_NAME = 'app.traveller.discard-seat';
const module = angular.module(MODULE_NAME, [])
    .directive(DiscardSeatOnTravellerChange.DIRECTIVE_NAME, DiscardSeatOnTravellerChange)
    .service('discardSeatOnTravellerChangeService', DiscardSeatOnTravellerChangeService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/traveller/discard-seat-on-traveller-change/discard-seat-on-traveller-change-module.js